import React, { useEffect, useRef, useState } from 'react';
import { PlayIcon } from "../../../../assets/icons/PlayIcon";
import { PauseIcon } from "../../../../assets/icons/PauseIcon";

import './styles.scss';
import classNames from "classnames";

interface AudioButtonProps {
  src: string;
  isRadio?: boolean;
  isSelected?: boolean;
  currentlyPlayingAudio?: string;
  setCurrentlyPlayingAudio?: (a: string) => void;
  onSelect?: () => void;
  selectedIsCorrect?: boolean;
  checkIsDone?: boolean;
  currentIndex?: number,
}

const AudioButton = ({
  src,
  isRadio = false,
  isSelected,
  currentlyPlayingAudio,
  setCurrentlyPlayingAudio,
  onSelect,
  selectedIsCorrect,
  checkIsDone,
  currentIndex,
}: AudioButtonProps) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleToggle = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
      setCurrentlyPlayingAudio?.('');
    } else {
      audioRef.current.play();
      setIsPlaying(true);
      // @ts-ignore
      setCurrentlyPlayingAudio?.(audioRef.current.getAttribute('src'));
    }
  };

  const onInputChange = (e: any) => {
    e.stopPropagation();
    onSelect?.();
  };

  useEffect(() => {
    if (audioRef.current) {
      console.log(currentIndex)
      console.log('audioRef.current.outerHTML', audioRef.current.outerHTML)
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
      setCurrentlyPlayingAudio?.('');
    }

    const audio = audioRef.current;
    if (!audio) return;

    const handleEnded = () => setIsPlaying?.(false);

    audio.addEventListener('ended', handleEnded);

    // Cleanup
    return () => {
      audio.removeEventListener('ended', handleEnded);
    };
  }, [currentIndex]);

  return (
    <div className={classNames("AudioButton", {
      "isPlaying": isPlaying,
      "isRadio": isRadio,
      "isCorrect": selectedIsCorrect,
      "isIncorrect": isSelected && checkIsDone && !(isSelected && selectedIsCorrect),
    })}
       // onClick={e => handleToggle(e)}
    >
      <div className="AudioButtonIcon"
        onClick={e => handleToggle(e)}>
        {!isPlaying ? <PlayIcon/> : <PauseIcon/>}
        {/*{!isPlaying ? <PlayIcon onClick={handleToggle}/> : <PauseIcon onClick={handleToggle}/>}*/}
      </div>
      <audio ref={audioRef} src={src} />
      {!!isRadio &&
        <label className="AudioButtonLabel">
          <input
            type="radio"
            name="audio"
            checked={isSelected}
            onChange={e => onInputChange(e)}
          />
        </label>
      }
    </div>
  );
};

export default AudioButton;
